import appConfig from '@frontend/env';
import { sentry } from '@frontend/tracking';

const backendApi = appConfig.BACKEND_API;

export const authorizedFetch = <T extends Record<string, any>>(
  token: string
): ((url: string, reqInit: RequestInit) => Promise<T>) => {
  return baseFetch<T>((r) => {
    r.headers = {
      ...r.headers,
      Authorization: `Bearer ${token}`,
    };
  });
};

export const baseFetch = <T extends Record<string, any>>(
  modifyReq?: (r: RequestInit) => void
): ((url: string, reqInit: RequestInit) => Promise<T>) => {
  return async (url: string, reqInit: RequestInit) => {
    if (modifyReq) {
      modifyReq(reqInit);
    }

    const res = await fetch(`${backendApi}${url}`, reqInit);
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json.message);
    }

    return json as T;
  };
};

export const getHostFromURL = (inUrl: string): string | undefined => {
  try {
    // Parse the requestUrl using the URL class
    const url = new URL(inUrl);

    // Extract and return the protocol and host property
    return `${url.protocol}//${url.host}`;
  } catch (error) {
    console.error('Error parsing requestUrl:', error);
    return;
  }
};

export const getRedirectURL = (requestUrl: string): string | undefined => {
  try {
    // Parse the requestUrl using the URL class
    const url = new URL(requestUrl);

    // Extract the value of the 'redirect_uri' query parameter
    const redirectUriParam = url.searchParams.get('redirect_uri');

    // Return the decoded value of the parameter
    return redirectUriParam ? getHostFromURL(decodeURIComponent(redirectUriParam)) : undefined;
  } catch (error) {
    console.error('Error parsing requestUrl:', error);
    sentry.error({
      error: 'Error parsing requestUrl',
      topic: 'auth',
    });
    return;
  }
};
